<template>
  <div v-loading="loading">
    <div class="maintitle">{{ $route.meta.title }}</div>
    <el-divider></el-divider>
    <el-row class="text-left">
      <el-col :span="6">
        <el-input v-model="keyword" placeholder="请输入会员id或公司全名" size="mini" @change="reset"></el-input>
      </el-col>
      <el-select v-model="type" size="mini" class="margin-left" @change="reset">
        <el-option label="视频" value="video"></el-option>
        <el-option label="讲解人" value="speaker"></el-option>
<!--        <el-option label="选题" value="topic"></el-option>-->
      </el-select>
      <el-select v-model="status" size="mini" class="margin-left" placeholder="请选择状态" v-if="type!=='speaker'"
                 clearable>
        <el-option label="选题未确认" :value="0"></el-option>
        <el-option label="已废弃" :value="1"></el-option>
        <el-option label="已确认" :value="2"></el-option>
        <el-option label="视频未确认" :value="4"></el-option>
      </el-select>
      <el-button @click="search" size="mini" class="margin-left">查询</el-button>
      <el-button @click="uploadVideoDiv=true" size="mini" v-if="memberId!==''">上传视频</el-button>
    </el-row>
    <el-table :data="list" border v-if="type==='video'" empty-text="暂无视频">
      <el-table-column prop="create_time" label="创建时间"></el-table-column>
      <el-table-column label="口播文案">
        <template v-slot="scope">
          <el-button size="mini" type="text" @click="showContent(scope.row.broadcast_content)" v-if="scope.row.broadcast_content !== ''">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="select_topic_name" label="选题名称"></el-table-column>
      <el-table-column prop="sku_url" label="sku商品链接"></el-table-column>
      <el-table-column prop="status_desc" label="状态"></el-table-column>
      <el-table-column prop="video_type" label="视频类型"></el-table-column>
      <el-table-column label="视频链接">
        <template #default="scope">
          <el-button type="text" @click="showVideo(scope.row.video_url)" v-if="scope.row.video_url !== ''">打开视频</el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template v-slot="scope">
          <el-button type="success" size="mini" @click="select(scope,2,'video')"
                     v-if="scope.row.status === 4">视频确认
          </el-button>
          <el-button type="danger" size="mini" @click="select(scope,1,'video')"
                     v-if="scope.row.status === 4">视频废弃
          </el-button>
          <el-button type="success" size="mini" @click="select(scope,2,'topic')" v-if="scope.row.status === 0">选题确认
          </el-button>
          <el-button type="danger" size="mini" @click="select(scope,1,'topic')" v-if="scope.row.status === 0">选题废弃
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-table :data="list" border v-if="type==='speaker'" empty-text="暂无讲解人">
      <el-table-column prop="create_time" label="创建时间" width="160"></el-table-column>
      <el-table-column :formatter="formatGender" label="性别" width="60"></el-table-column>
      <el-table-column prop="human_id" label="数字人模板id" width="160"></el-table-column>
      <el-table-column prop="human_voice" label="数字人声音"></el-table-column>
      <el-table-column prop="manufacturer_name" label="厂家名称" min-width="200"></el-table-column>
      <el-table-column prop="reject_reason" label="拒绝原因"></el-table-column>
      <el-table-column prop="speaker_name" label="讲解人名称"></el-table-column>
      <el-table-column prop="speaker_position" label="讲解人职位"></el-table-column>
      <el-table-column label="讲解人视频">
        <template #default="scope">
          <el-button type="text" @click="showVideo(scope.row.speaker_video)">打开视频</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="speaker_voice" label="讲解人声音">
        <template #default="scope">
          <el-button v-if="scope.row.speaker_voice !== ''" type="text" @click="showVideo(scope.row.speaker_voice)">
            打开音频
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="status_desc" label="状态"></el-table-column>
      <el-table-column prop="update_time" label="更新时间" width="160"></el-table-column>
      <el-table-column label="操作">
        <template v-slot="scope">
          <el-button @click="mdfy(scope)" type="text">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-table :data="list" border v-if="type==='topic'" empty-text="暂无选题">
      <el-table-column prop="create_time" label="创建时间"></el-table-column>
      <el-table-column label="口播文案">
        <template v-slot="scope">
          <el-button size="mini" type="text" @click="showContent(scope.row.broadcast_content)" v-if="scope.row.broadcast_content !== ''">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="select_topic_name" label="选题名称"></el-table-column>
      <el-table-column prop="sku_url" label="sku商品链接"></el-table-column>
      <el-table-column prop="status_desc" label="状态"></el-table-column>
      <el-table-column prop="update_time" label="更新时间"></el-table-column>
      <el-table-column prop="video_type" label="视频类型"></el-table-column>
      <el-table-column prop="video_url" label="视频链接"></el-table-column>
      <el-table-column label="操作">
        <template v-slot="scope">
          <el-button type="success" size="mini" @click="select(scope,2,'topic')" v-if="scope.row.status === 0">确认
          </el-button>
          <el-button type="danger" size="mini" @click="select(scope,1,'topic')" v-if="scope.row.status === 0">废弃
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background :current-page="page" :page-sizes="pagesizes" :page-size="pagesize"
                   @size-change="handleSizeChange" @current-change="handleCurrentChange"
                   layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    <el-dialog :visible.sync="uploadVideoDiv" @closed="resetInfo">
      <el-form :label-width="formLabelWidth">
        <el-form-item label="性别" class="text-left" v-if="videoInfo.id === ''">
          <el-select v-model="videoInfo.gender">
            <el-option label="男" value="MALE"></el-option>
            <el-option label="女" value="FEMALE"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="厂家名">
          <el-input v-model="videoInfo.manufacturer_name" placeholder="请输入厂家名"></el-input>
        </el-form-item>
        <el-form-item label="讲解人姓名">
          <el-input v-model="videoInfo.speaker_name" placeholder="请输入讲解人姓名"></el-input>
        </el-form-item>
        <el-form-item label="讲解人职位">
          <el-input v-model="videoInfo.speaker_position" placeholder="请输入讲解人职位"></el-input>
        </el-form-item>
        <el-form-item label="厂家视频" class="text-left" v-if="videoInfo.id === ''">
          <upload-to-oss ref="refuploadoss" @success="showRes" @uploading="showloading"
                         @uploaded="hideloading" accept=".mp4,.mpeg" path="video" hasDate
                         btnText="视频"></upload-to-oss>

        </el-form-item>
        <el-form-item label="厂家音频" class="text-left" v-if="videoInfo.id === ''">
          <upload-to-oss ref="refuploadoss" @success="showRes" @uploading="showloading"
                         @uploaded="hideloading" accept=".mp3,.wav" path="voice" hasDate
                         btnText="音频"></upload-to-oss>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="uploadVideoDiv=false">取消</el-button>
        <el-button @click="submit">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="contentDiv">
      <div style="line-height: 40px;padding:20px;text-align: left">{{content}}</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="contentDiv=false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import uploadToOss from "@/components/uploadToOss.vue";

export default {
  components: {
    uploadToOss,
  },
  data() {
    return {
      keyword: '',
      loading: false,
      list: [],
      area: '',
      memberId: '',
      uploadVideoDiv: false,
      videoInfo: {
        id: '',
        gender: 'MALE',//性别
        manufacturer_name: '',//厂家名
        speaker_name: '',//讲解人姓名
        speaker_position: '',//讲解人职位
        speaker_video: '',//厂家视频
        speaker_voice: '',//厂家音频
      },
      tempInfo: {},
      type: 'video',
      page: 1,
      total: 0,
      status: '',
      crntScope: '',
      contentDiv:false,
      content:''
    }
  },
  methods: {
    handleSizeChange(size) {
      this.pagesize = size;
      this.page = 1;
      this.getlist();
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getlist();
    },
    showloading() {
      this.loading = true
    },
    hideloading() {
      this.loading = false
    },
    showRes(res) {
      this.$axios({
        url: this.HOST + '/admin.membagent/upFile',
        method: 'post',
        data: {
          file: res.host + '/' + res.fileUrl,
          area: this.area
        }
      }).then(rest => {
        console.log(rest)
        if (rest.data.status === 1) {
          this.videoInfo['speaker_' + res.path] = rest.data.file;
        }
        console.log(this.videoInfo)
      })
    },
    getlist() {
      if (this.keyword === '') {
        this.$message({
          type: 'error',
          message: '请输入要查询的公司全名或会员id'
        })
        return;
      }
      this.$axios({
        url: this.HOST + '/admin.membagent/getVideoList',
        method: 'post',
        data: {
          memberId: this.keyword,
          type: this.type,
          page: this.page,
          pagesize: this.pagesize,
          status:this.status,
        }
      }).then(res => {
        if (res.data.status === 1) {
          if (res.data.list.length === 0) {
            this.$message({
              type: 'success',
              message: '暂无数据'
            })
          }
          this.list = res.data.list;
          this.area = res.data.area;
          this.memberId = res.data.member_id;
          this.total = res.data.total;
        } else {
          this.memberId = ''
        }
      })
    },
    submit() {
      this.$axios({
        url: this.HOST + '/admin.membagent/saveSpeakerInfo',
        method: 'post',
        data: {
          memberId: this.memberId,
          area: this.area,
          info: this.videoInfo
        }
      }).then(res => {
        if (res.data.status === 1) {
          this.uploadVideoDiv = false;
          this.type = 'speaker';
          this.search();
        }
      })
    },
    formatGender(row) {
      return row.gender === 'MALE' ? '男' : '女';
    },
    mdfy(scope) {
      this.videoInfo = {
        id: scope.row.id,
        manufacturer_name: scope.row.manufacturer_name,
        speaker_name: scope.row.speaker_name,
        speaker_position: scope.row.speaker_position,
      }
      this.uploadVideoDiv = true;
    },
    search() {
      this.reset();
      this.getlist();
    },
    reset() {
      this.page = 1;
      this.list = [];
    },
    resetInfo() {
      for (let item in this.videoInfo) {
        this.videoInfo[item] = this.tempInfo[item];
      }
    },
    select(scope, status, type) {
      const act = status === 1 ? '废弃' : '确认';
      type = type==='video'?'视频':'选题';
      this.$confirm(`确定${act}该${type}吗？`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios({
          url: this.HOST + '/admin.membagent/videoConfirm',
          method: 'post',
          data: {
            id: scope.row.id,
            status: status,
            memberId: this.memberId,
            area: this.area,
            type: type
          }
        }).then(res => {
          if (res.data.status === 1) {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            if(status !== ''){
              this.list.splice(scope.$index, 1);
            }
          }
        })
      })
    },
    showVideo(video) {
      window.open(video, '_blank')
    },
    showContent(content){
      this.content = content;
      this.contentDiv = true;
    },
  },
  mounted() {
    this.tempInfo = JSON.parse(JSON.stringify(this.videoInfo));
  }
}
</script>